const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarryingHeart(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 64000 64000",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m36247 47816 16416-3241c2628-584 4289-216 4599 1259l-18856 3752c-53 11-103 2-149-29l-2082-1379c-69-45-102-124-86-205s77-141 158-157zm237-39817c39 70 108 110 187 110 82 0 152-40 191-110 3071-5406 7771-9582 14202-7415 4948 1666 8530 6551 8530 12316 0 8200-8416 14853-13831 20134l-7612 7010c-838 772-2119 772-2956 0l-7613-7010c-5414-5281-13830-11934-13830-20134 0-5919 3775-10911 8930-12443 6285-1871 10832 2316 13802 7542zM9544 39757c3899-2529 8195-2366 11749-711 2322 1081 4081 3249 6244 4554l5347 3001c2800 1548 1381 5495-1204 4915l-5561-723c-683-88-1254-304-1812-706l-6162-4450c-586-471-1296 463-612 919l6241 4703c555 418 1508 775 2198 870l5548 765c1909 266 3534-595 4124-2711 18-62 59-108 118-132 60-24 121-20 177 13l1628 965c44 26 91 34 142 24l21794-4521c4735-872 6480 4896 1524 6095l-23332 7423c-3606 1147-7076 1502-10626 194l-11497-4235c-1021-376-2102-366-3001 248L1701 63677c-579 396-1701 624-1701-521V48524c0-1798 449-2643 1253-3310 2410-2002 7301-4814 8291-5457z",
    style: {
      fill: "#000"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarryingHeart);
export default __webpack_public_path__ + "static/media/carrying-heart.1daadbe1c4eb253ed1090f3172c0ef14.svg";
export { ForwardRef as ReactComponent };